import { useAuth } from "./useAuth";

export const useIsLoggedOn = (): boolean => {
  const [{ tokenIsAuthenticated }] = useAuth();
  return tokenIsAuthenticated;
};
